module.exports = __webpack_public_path__ + "img/default-avatar.6da9c468.jpg";